import styled from 'styled-components';
import { complianceStatus } from '../../providers/compliance-status';
import enumQuestionResponseStatus from '../../enum/enumQuestionResponseStatus';

const Element = styled.span`
  color: ${(props) => props.variant.color};
  padding: 6px 10px;
  border-radius: 8px;
  font-weight: bold;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border: 1px solid ${(props) => props.variant.color};
  background: ${(props) => (props.active ? props.variant.background : 'none')};
  width: 150px;
  height: 32px;
  flex-shrink: 0;

  @media (max-width: 550px) {
    display: none;
  }
`;

const ComplianceLabelText = styled.span`
  font-size: 8px;
  font-weight: 500;
  margin-bottom: 1px;
  opacity: 0.8;
  line-height: 1;
  text-transform: uppercase;
  letter-spacing: 0.3px;
`;

const ComplianceValue = styled.span`
  font-size: 12px;
  font-weight: 700;
  line-height: 1;
`;

const ComplianceLabel = ({ status, activeBC }) => {
  if (status !== enumQuestionResponseStatus.NOT_ANSWERED) {
    return (
      <Element variant={complianceStatus[status]} active={activeBC}>
        <ComplianceLabelText>Status</ComplianceLabelText>
        <ComplianceValue>{complianceStatus[status].label}</ComplianceValue>
      </Element>
    );
  }

  // Status para Pendente
  const pendingStatus = {
    label: 'Pendente',
    icon: 'bx bx-time',
    background: '#f3f4f6',
    color: '#6b7280',
  };

  return (
    <Element variant={pendingStatus} active={false}>
      <ComplianceLabelText>Status</ComplianceLabelText>
      <ComplianceValue>{pendingStatus.label}</ComplianceValue>
    </Element>
  );
};

export default ComplianceLabel;
